var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "results__section" }, [
    _c("div", { staticClass: "results__wrapper" }, [
      _vm.resultsExplainerText
        ? _c("div", [
            _c(
              "p",
              {
                staticClass: "p-large results__explainer-text",
                domProps: { innerHTML: _vm._s(_vm.resultsExplainerText) },
              },
              [_vm._v(_vm._s(_vm.resultsExplainerText))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isTab2
        ? _c("div", [
            _vm.loading
              ? _c(
                  "div",
                  [_c("Loader", { attrs: { loading: _vm.loading } })],
                  1
                )
              : _vm.providers.error
              ? _c("div", [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.providers.errorMessage) },
                  }),
                ])
              : _vm.messageType == "error"
              ? _c(
                  "div",
                  [
                    _c("APIErrorMsg", {
                      attrs: {
                        message: _vm.message,
                        messageType: _vm.messageType,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("ResultsList", {
                      attrs: {
                        isTab2: _vm.isTab2,
                        noResultsText: _vm.noResultsText,
                        providers: _vm.providers.providers,
                        providerCount: _vm.providerCount,
                        resultsExplainerText: _vm.resultsExplainerText,
                        showNoResultsText: _vm.showNoResultsText,
                        showResultsCountText: _vm.showResultsCountText,
                        supplierCount: _vm.supplierCount,
                        suppliers: _vm.suppliers,
                      },
                    }),
                  ],
                  1
                ),
          ])
        : _c("div", [
            _vm.loading
              ? _c(
                  "div",
                  [_c("Loader", { attrs: { loading: _vm.loading } })],
                  1
                )
              : _vm.providers.error
              ? _c("div", [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.providers.errorMessage) },
                  }),
                ])
              : _vm.messageType == "error"
              ? _c(
                  "div",
                  [
                    _c("APIErrorMsg", {
                      attrs: {
                        message: _vm.message,
                        messageType: _vm.messageType,
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("ResultsList", {
                      attrs: {
                        isTab2: _vm.isTab2,
                        noResultsText: _vm.noResultsText,
                        providerCount: _vm.providerCount,
                        providers: _vm.providers.providers,
                        resultsExplainerText: _vm.resultsExplainerText,
                        resultsToShow: 20,
                        showNoResultsText: _vm.showNoResultsText,
                        showResultsCountText: _vm.showResultsCountText,
                      },
                    }),
                  ],
                  1
                ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }